export const ERROR_SNACKBAR_SUPPORT_CLICK = '[Error Snackbar] support click';
export const ERROR_SNACKBAR_TROUBLESHOOT_BUTTON_SHOWN = '[Error Snackbar] troubleshoot button shown'
export const ERROR_SNACKBAR_TROUBLESHOOT_BUTTON_CLICK = '[Error Snackbar] troubleshoot button click'
